import { ApiLogService as api } from '@/services/axiosHelper';

import buildRoute from '@/composables/build-route';

export default new (class LogsService {
	constructor() {}
	async GetLogs(parameters, logType) {
		let apiLogType = logType || 'changeaudit';
		return await api.get(buildRoute(`/${apiLogType}`, parameters));
	}
})();
